export const CurriculumStatus = {
    DRAFT: 'DRAFT',
    APPROVED: 'APPROVED',
    ARCHIVED: 'ARCHIVED',
};
/** Значення в порядку оголошення в схемі. */
export const CURRICULUM_STATUS_VALUES = ['DRAFT', 'APPROVED', 'ARCHIVED'];
export const CURRICULUM_STATUS_LABELS = {
    DRAFT: 'Чернетка',
    APPROVED: 'Затверджено',
    ARCHIVED: 'Архів',
};
export const CURRICULUM_STATUS_TONES = {
    DRAFT: 'neutral',
    APPROVED: 'success',
    ARCHIVED: 'neutral',
};
//# sourceMappingURL=curriculum-status.js.map